// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    id: z.string().min(1).max(21),
    tenantId: z.string().max(21).optional(),
    userId: z.string().min(1).max(21),
    date: z.number(),
});
const guard = z.object({
    id: z.string().min(1).max(21),
    tenantId: z.string().max(21),
    userId: z.string().min(1).max(21),
    date: z.number(),
});
export const DailyActiveUsers = Object.freeze({
    table: 'daily_active_users',
    tableSingular: 'daily_active_user',
    fields: {
        id: 'id',
        tenantId: 'tenant_id',
        userId: 'user_id',
        date: 'date',
    },
    fieldKeys: [
        'id',
        'tenantId',
        'userId',
        'date',
    ],
    createGuard,
    guard,
});
